import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Transaction } from '../../models/transaction';
import { BaseService } from '../base/base.service';

@Injectable()
export class DocumentDataService extends BaseService {
    constructor(private http: HttpClient) {
        super();
    }

    public getConditionsPdf(brandName: string, key: string, tag: string): Observable<any> {
        const apiUrl = environment.apiUrl + '/Content/Documents';

        this.setHttpOptions();
        this.setHttpParam('brandName', brandName);
        this.setHttpParam('key', key);
        this.setHttpParam('tag', tag);

        return this.http.get<any>(apiUrl, this.httpOptions)
            .pipe(catchError(this.handleError));
    }

    public getQuotePdf(transaction: Transaction): Observable<any> {
        const apiUrl = environment.apiUrl + '/Document/PDFQuotation';
        if (environment.mockData) {
            //apiUrl = 'mock-data/transaction-status.json';
        }

        this.setHttpOptions();
        this.httpOptions.headers = this.httpOptions.headers.set('Accept', 'application/pdf');
        return this.http.post<any>(apiUrl, JSON.stringify(transaction), { headers: this.httpOptions.headers, responseType: 'blob' as 'json' })
            .pipe(catchError(this.handleError));
    }

    public getContractPdf(transaction: Transaction): Observable<any> {
        const apiUrl = environment.apiUrl + '/Document/PDFContract';
        if (environment.mockData) {
            //apiUrl = 'mock-data/transaction-status.json';
        }

        this.setHttpOptions();
        this.httpOptions.headers = this.httpOptions.headers.set('Accept', 'application/pdf');
        return this.http.post<any>(apiUrl, JSON.stringify(transaction), { headers: this.httpOptions.headers, responseType: 'blob' as 'json' })
            .pipe(catchError(this.handleError));
    }
}
